import React, { useState, useRef, useEffect } from "react";
import { Play, Pause } from "lucide-react";

const HeroSection = () => {
  const [isPlaying, setIsPlaying] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const videoRef = useRef(null);

  // Handle scroll to adjust padding
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className={`flex justify-center items-center py-8 transition-all duration-300 ${
      isScrolled ? 'pt-20' : 'pt-24'
    }`}>
      <div className="relative w-[398px] max-w-full h-[398px] md:w-full md:max-w-[1140px] md:h-[583.68px] flex items-center justify-center overflow-hidden rounded-lg group">
        {/* Background Video */}
        <div className="absolute inset-0">
          <video
            ref={videoRef}
            autoPlay
            muted
            loop
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
            poster="https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=1140&h=584&fit=crop"
            onPlay={() => setIsPlaying(true)}
            onPause={() => setIsPlaying(false)}
          >
            <source src="/videos/The%20Ritz-Carlton-2026.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Video Controls */}
        {/* Bottom Right Play/Pause Button */}
        <button
          onClick={togglePlay}
          className="absolute bottom-6 right-6 bg-black/40 hover:bg-black/60 text-white rounded-full w-10 h-10 flex items-center justify-center transition-all duration-300 opacity-0 group-hover:opacity-100 backdrop-blur-sm"
        >
          {isPlaying ? (
            <Pause className="w-4 h-4" />
          ) : (
            <Play className="w-4 h-4 ml-0.5" />
          )}
        </button>

        {/* Video Controls Overlay (shows on hover) */}
        <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
      </div>
    </div>
  );
};

export default HeroSection;
